import React from 'react'
import { observer, inject } from 'mobx-react'
import * as linkConst from '../../constants/link_constants'
import ArchiveDetailView from '../archive/manip'
import ArtistEditView from '../artists/manip'
import CReportsEditView from '../creports/manip'
import ClientEditView from '../clients/manip'
import ContractEditView from '../contracts/manip'
import ContractTimeRestEditView from '../contract_time_restrictions/manip'
import EnumsSetEditView from '../enums_settings/manip'
import FPVCategoriesEditView from '../fpv_categories/manip'
import FPVSettingEditView from '../fpv_settings/manip'
import FPVTestingEditView from '../fpv_testing/manip'
import FilmcargoHelpEditView from '../filmcargo_help/manip'
import FilmsEditView from '../films/manip'
import PPRollsEditView from '../pprolls/manip'
import PPRollsUploadEditView from '../uploading/manip'
import PricingEditView from '../pricings/manip'
import RatingEditView from '../rating/manip'
import RightsEditView from '../rights/manip'
import VATratesEditView from '../vatrates/manip'
import XratesEditView from '../xrates/manip'
import YTAssetsEditView from '../youtube_assets/manip'

const EntityEdit = ({ store }) => {
  const entityname = store.router.params.entityname
  switch (entityname) {
  case 'archive': return <ArchiveDetailView store={store} />
  case 'clients': return <ClientEditView store={store} />
  case 'contract_time_restrictions': return <ContractTimeRestEditView store={store} />
  case 'contracts': return <ContractEditView store={store} />
  case 'filmcargo_help': return <FilmcargoHelpEditView store={store} />
  case 'films': return <FilmsEditView store={store} />
  case 'flyprivate_categories_settings': return <FPVCategoriesEditView store={store} />
  case 'flyprivate_homepage_settings': return <FPVSettingEditView store={store} />
  case 'flyprivate_pricing': return <PricingEditView store={store} />
  case 'flyprivate_testing': return <FPVTestingEditView store={store} />
  case 'persons': return <ArtistEditView store={store} />
  case 'pprolls': return <PPRollsEditView store={store} />
  case 'pprolls_upload': return <PPRollsUploadEditView store={store} />
  case 'rating': return <RatingEditView store={store} />
  case 'reports': return <CReportsEditView store={store} />
  case 'rights': return <RightsEditView store={store} />
  case 'vatrates': return <VATratesEditView store={store} />
  case 'xrates': return <XratesEditView store={store} />
  case linkConst.LINK_CATEG_SETTINGS: return <EnumsSetEditView store={store} />
  case linkConst.LINK_TIERS_SETTINGS: return <EnumsSetEditView store={store} />
  case linkConst.LINK_YOUTUBE_ASSETS: return <YTAssetsEditView store={store} />
  }
  return null
  // throw new Error('Invalid entity name to render: ' + entityname)
}

export default inject('store')(observer(EntityEdit))
